import { useEffect, useState } from "react";
import { getGlpiClient } from "../services/glpiClient";
import { GlpiUser } from "../types/glpi";

export interface UseRequesterSearchResult {
  results: GlpiUser[];
  loading: boolean;
  error: string | null;
}

/**
 * Recherche débouncée (300 ms) d'utilisateurs GLPI par nom/login.
 * Vide la query -> renvoie un tableau vide.
 */
export function useRequesterSearch(query: string, debounceMs = 300): UseRequesterSearchResult {
  const [results, setResults] = useState<GlpiUser[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const trimmed = query.trim();
    if (trimmed.length < 2) {
      setResults([]);
      setLoading(false);
      setError(null);
      return;
    }
    const client = getGlpiClient();
    if (!client) return;

    let cancelled = false;
    const handle = window.setTimeout(() => {
      setLoading(true);
      setError(null);
      client
        .searchUserByName(trimmed)
        .then((data) => {
          if (!cancelled) setResults(data);
        })
        .catch((e: Error) => {
          if (!cancelled) setError(e.message);
        })
        .finally(() => {
          if (!cancelled) setLoading(false);
        });
    }, debounceMs);

    return () => {
      cancelled = true;
      window.clearTimeout(handle);
    };
  }, [query, debounceMs]);

  return { results, loading, error };
}
